import React from 'react';

import { StyledIndicator, Variants } from '@pkg/components/Sections/Profile/Indicator/styles';

interface IndicatorProps {
    value?: number;
    variant?: Variants;
}

export const Indicator = ({ value, variant = Variants.primary }: IndicatorProps) => {
    return <StyledIndicator $variant={variant}>{value && <span>{value}</span>}</StyledIndicator>;
};
